import api  from "./api";
import { API_MS_SURVEY_TEMPLATES } from "../constants/urls"

/**
 * Servicio para buscar, crear, modificar y eliminar template de whatsapp ya que hay que cargarlos manualmente,
 * el usuario no puede hacerlo a traves de debQ.
 *
 * Definición del objeto de template
 * @param {object}  template Template object
 * @param {number}  template.id Id del template
 * @param {number}  template.companyId DashCompanyId del template
 * @param {string}  template.channelType Tipo de canal
 * @param {string}  template.name Nombre del template, los de whatsapp tiene como name la key que se usa para buscar el template en Whatsapp
 * @param {string}  template.template Body del template
 * @param {boolean} template.defaultTemplate True si es comun a todas las compañias, false si es de una compañia en particular
 * @param {string}  template.finalMessage Mensaje al finalizar la encuesta.
 * @param {string}  template.messageNoAnswer Mensaje al no completar la encuesta.
 */

export const surveyTemplates = {
    getWhatsappTemplates: async () => (await api.get(`${API_MS_SURVEY_TEMPLATES}?channelTypes=WHATSAPP&channelTypes=WHATSAPP_LINK&defaultTemplate=false`)).data,
    getById: async (id) => (await api.get(`${API_MS_SURVEY_TEMPLATES}/${id}`)).data,
    create: async (template) => (await api.post(API_MS_SURVEY_TEMPLATES, template)).data,
    update: async (template) => (await api.put(`${API_MS_SURVEY_TEMPLATES}/${template.id}`, template)).data,
    delete: async (id) => (await api.delete(`${API_MS_SURVEY_TEMPLATES}/${id}`)).data,
}